import styled, {css} from 'styled-components'

export const StyledAgendaSearchNoResultsWrapper = styled.div(
    ({theme: {spacing}}) => css`
        padding: 0 ${spacing * 2}px 0 ${spacing * 8}px;
        width: 100%;
    `
)

export const StyledComboboxItemTrimmedText = styled.span(
    () => css`
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    `
)
